<template>
  <div>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div>
            <p class="heading">{{$route.params.service}}</p>
            <p v-if="serviceData.title" class="title has-text-primary">{{serviceData.title}}</p>
          </div>
        </div>
      </div>

      <div class="level-right">
        <div class="level-item">
          <b-button @click="showPicker = true" type="is-primary" icon-left="plus">Pick</b-button>
        </div>
      </div>
    </div>

    <b-loading v-model="loading" />

    <div v-for="pick in picks" :key="pick.id" class="box">
      <parlay-editor v-if="pick.type === 'Parlay'" :parlay="pick" @pickRemoved="removePick" />
      <pick-editor v-else :pick="pick" @pickRemoved="removePick" @pickUpdated="updatePick" />
    </div>

    <b-modal v-model="showPicker">
      <div class="box">
        <leagues @picked="gamePicked"
                 @parlayPicked="parlayPicked"
                 @fromScratch="addPickFromScratch"
                 @parlayFromScratch="addParlayFromScratch" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { getAdminPicks, getServices } from '@/utils/api';
import {randomString} from '@/utils/misc';
import PickEditor from '@/components/admin/PickEditor';
import ParlayEditor from '@/components/admin/ParlayEditor';
import Leagues from '@/components/admin/Leagues';

export default {
  components: {
    PickEditor,
    ParlayEditor,
    Leagues
  },
  data() {
    return {
      picks: [],
      parlays: [],
      serviceData: {},
      loading: true,
      showPicker: false,
    }
  },
  mounted() {
    this.init()
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    parlayPicked: function (games) {
      let { picks } = this;
      let parlayId = `${Object.keys(games).join('|')}-${randomString()}`;
      let parlayPicks = [];

      for (let eventId in games) {
        let game = games[eventId];

        console.log({eventId, game});

        let {body, homeTeam, awayTeam, dateTime, type} = game;

        parlayPicks = parlayPicks.concat(body.map(pickBody => {
          return {body: pickBody, homeTeam, awayTeam, dateTime, type, id: randomString()};
        }));
      }

      let parlay = {
        id: parlayId,
        service: this.$route.params.service,
        title: this.serviceData.title,
        bets: parlayPicks,
        type: 'Parlay',
        risk: 0,
        gain: 0,
        instructions: ''
      }

      if (Array.isArray(picks)) {
        this.picks = [parlay, ...picks];
      } else {
        this.picks = [parlay];
      }

      this.showPicker = false;
    },
    addParlayFromScratch: function () {
      let parlay = {
        id: randomString(),
        service: this.$route.params.service,
        title: this.serviceData.title,
        bets: [],
        type: 'Parlay',
        risk: 0,
        gain: 0,
        instructions: ''
      };

      if (Array.isArray(this.picks)) {
        this.picks = [parlay, ...this.picks];
      } else {
        this.picks = [parlay];
      }

      this.showPicker = false;
    },
    updatePick: function (pick) {
      let position = -1;
      let filteredPicks = this.picks.filter((oldItem, i) => {
        let willBeRemoved = oldItem.id === pick.id;
        if (willBeRemoved) {
          position = i;
        }

        return !willBeRemoved;
      });

      if (position >= 0) {
        filteredPicks.splice(position, 0, pick);
      }

      this.picks = filteredPicks;
    },
    gamePicked: function (e) {
      let { picks } = this;
      let {body, homeTeam, awayTeam, dateTime, type} = e;
      let newPick = {
        id: randomString(),
        service: this.$route.params.service,
        title: this.serviceData.title,
        body,
        homeTeam,
        awayTeam,
        dateTime,
        type
      };

      if (Array.isArray(picks)) {
        this.picks = [newPick, ...picks];
      } else {
        this.picks = [newPick];
      }

      this.showPicker = false;
    },
    init: async function () {
      let storedService = JSON.parse(localStorage.getItem('service'));
      let currentService = this.$route.params.service;

      let res = await getAdminPicks({service: currentService});

      if (res.ok) {
        let picks = await res.json();
        this.picks = picks.filter(pick => !pick.isParlay);
        this.parlays = picks.filter(pick => pick.isParlay);
      }

      if (storedService && storedService.code === currentService) {
        this.serviceData = storedService;
        return;
      }

      let serviceRes = await getServices(currentService);

      if (serviceRes.ok) {
        let data = await res.json();

        this.serviceData = data[currentService];
      }

      if (!serviceRes.ok) {
        this.$buefy.toast.open({
          message: 'Could not load services',
          type: 'is-danger'
        })
      }
    },
    addPickFromScratch: function () {
      let { picks } = this;
      let newPick = {
        id: randomString(),
        service: this.$route.params.service,
        title: this.serviceData.title
      };

      if (Array.isArray(picks)) {
        this.picks = [newPick, ...picks];
      } else {
        this.picks = [newPick];
      }

      this.showPicker = false;
    },
    removePick: function (pick) {
      this.picks = this.picks.filter(oldPick => oldPick.id !== pick.id);
    }
  }
}
</script>